export enum EntityState {
  NEW,
  PERSISTING,
  PERSISTED,
  UPDATING,
  UPDATED,
  REMOVING,
  REMOVED,

  LOADING
}